module.exports = __webpack_public_path__ + "media/3d-GIS-2.c95da1ff.mp4";